import React, { createRef, Component } from 'react';

import { Navigate } from 'react-router-dom';

// eslint-disable-next-line

import DeviceData from 'drivers/deviceData';

import Route from 'enum/route.enum';

import EventBus from 'utils/eventBus';

import getIsRTLLanguage from 'utils/common/isRTL';

import { translate as t } from 'utils/i18n';

import { loadLanguagesFromStorage, persistLocale } from 'utils/settings/languageUtils';

import {

  loadHdmiPortsForSettings,

  getHdmiSettingsCategory,

  mapSourcesToSettingsItems,

  buildSourceRoutePath,

} from 'utils/hdmi/hdmiSettingsData';



import { Container } from './styles';

import HeaderBarComponent from './components/HeaderBar';

import PageHeader from './components/PageHeader';

import SettingsPanel from './components/SettingsPanel';

import { OuterContentContainer, ContentContainer } from 'design-tokens/warwick/common';



const SECTION = {

  LEFT_COLUMN: 'leftColumn',

  RIGHT_COLUMN: 'rightColumn',

  BACK_BUTTON: 'backButton',

};



const CATEGORY_LANGUAGE = 'language';

const CATEGORY_SOURCE = 'source';



class WarwickSettings extends Component {

  constructor(props) {

    super(props);

    this.backButtonRef = createRef();

    this.subscriptions = {};

    this.state = {

      focusedSection: SECTION.LEFT_COLUMN,

      leftFocusIndex: 0,

      rightFocusIndex: 0,

      languages: [],

      hdmiPorts: [],

      selectedLanguageId: null,

      redirectBack: false,

      sourceRedirect: null,

      categories: [],

    };

    this.onKeyPress = this.onKeyPress.bind(this);

    this.loadData = this.loadData.bind(this);

  }



  componentDidMount() {

    this.subscriptions['refresh'] = EventBus.subscribe('refresh', this.loadData);

    window.addEventListener('keydown', this.onKeyPress);

    this.loadData();

    DeviceData.addHdmiSourceChangeListener(this.applyHdmiPorts.bind(this));

  }



  componentWillUnmount() {

    this.subscriptions['refresh']?.unsubscribe();

    window.removeEventListener('keydown', this.onKeyPress);

    DeviceData.removeHdmiSourceChangeListener();

  }



  applyHdmiPorts(inputs) {

    var sourceItems = mapSourcesToSettingsItems(inputs);

    this.setState(function (prev) {

      return {

        hdmiPorts: sourceItems,

        categories: WarwickSettings.buildCategories(sourceItems),

        leftFocusIndex: Math.min(prev.leftFocusIndex, WarwickSettings.buildCategories(sourceItems).length - 1),

      };

    });

  }



  static buildCategories(hdmiPorts) {

    var categories = [{ id: CATEGORY_LANGUAGE, label: t('buttons.languageTittle') }];

    if (hdmiPorts.length > 0) {

      categories.push(getHdmiSettingsCategory());

    }

    return categories;

  }



  getRightItems() {

    var categories = this.state.categories;

    var leftFocusIndex = this.state.leftFocusIndex;

    var active = categories[leftFocusIndex];

    if (active && active.id === CATEGORY_SOURCE) {

      return this.state.hdmiPorts;

    }

    return this.state.languages;

  }



  async loadData() {

    const { languages: rawLanguages, selectedLanguageId } = loadLanguagesFromStorage();



    const languages = rawLanguages.map((lang) => ({

      id: lang.id,

      label: lang.language_name,

      language_code: lang.language_code,

    }));



    const savedIndex = languages.findIndex((l) => l.id === selectedLanguageId);

    const rightFocusIndex = savedIndex >= 0 ? savedIndex : 0;



    const hdmiPorts = await loadHdmiPortsForSettings();



    this.setState({

      languages,

      hdmiPorts,

      selectedLanguageId,

      rightFocusIndex,

      categories: WarwickSettings.buildCategories(hdmiPorts),

    });

  }



  setLocale(languageId) {

    persistLocale(languageId, this.state.languages);

    this.setState({ selectedLanguageId: languageId });

  }



  openSource(item) {

    this.setState({

      sourceRedirect: { type: item.sourceType, number: item.number },

    });

  }



  focusSection(section) {

    this.setState({ focusedSection: section });



    if (section === SECTION.BACK_BUTTON) {

      this.backButtonRef.current?.focus();

    } else {

      this.backButtonRef.current?.blur();

    }

  }



  async onKeyPress(event) {

    const tvKeyControls = await DeviceData.getTVControl();

    const isRTL = getIsRTLLanguage();

    const { focusedSection, leftFocusIndex, rightFocusIndex, categories } = this.state;

    const rightItems = this.getRightItems();

    const activeCategory = categories[leftFocusIndex];



    const KEY_UP = isRTL ? tvKeyControls.KEY_DOWN : tvKeyControls.KEY_UP;

    const KEY_DOWN = isRTL ? tvKeyControls.KEY_UP : tvKeyControls.KEY_DOWN;

    const KEY_LEFT = isRTL ? tvKeyControls.KEY_RIGHT : tvKeyControls.KEY_LEFT;

    const KEY_RIGHT = isRTL ? tvKeyControls.KEY_LEFT : tvKeyControls.KEY_RIGHT;



    const { keyCode } = event;



    if (focusedSection === SECTION.LEFT_COLUMN) {

      if (keyCode === KEY_UP) {

        const next = leftFocusIndex - 1;

        this.setState({

          leftFocusIndex: next < 0 ? categories.length - 1 : next,

          rightFocusIndex: 0,

        });

      } else if (keyCode === KEY_DOWN) {

        const next = leftFocusIndex + 1;

        this.setState({

          leftFocusIndex: next >= categories.length ? 0 : next,

          rightFocusIndex: 0,

        });

      } else if (keyCode === KEY_RIGHT || keyCode === tvKeyControls.KEY_ENTER) {

        if (rightItems.length > 0) {

          this.focusSection(SECTION.RIGHT_COLUMN);

        }

      } else if (keyCode === tvKeyControls.KEY_BACK) {

        event.preventDefault();

        this.setState({ redirectBack: true });

      }

      return;

    }



    if (focusedSection === SECTION.RIGHT_COLUMN) {

      if (rightItems.length === 0) {

        return;

      }



      if (keyCode === KEY_UP) {

        const next = rightFocusIndex - 1;

        this.setState({ rightFocusIndex: next < 0 ? rightItems.length - 1 : next });

      } else if (keyCode === KEY_DOWN) {

        const next = rightFocusIndex + 1;

        this.setState({ rightFocusIndex: next >= rightItems.length ? 0 : next });

      } else if (keyCode === KEY_LEFT) {

        event.preventDefault();

        this.focusSection(SECTION.LEFT_COLUMN);

      } else if (keyCode === KEY_RIGHT) {

        this.focusSection(SECTION.BACK_BUTTON);

      } else if (keyCode === tvKeyControls.KEY_ENTER) {

        const selected = rightItems[rightFocusIndex];

        if (!selected) {

          return;

        }

        if (activeCategory && activeCategory.id === CATEGORY_SOURCE) {

          this.openSource(selected);

        } else {

          this.setLocale(selected.id);

        }

      } else if (keyCode === tvKeyControls.KEY_BACK) {

        event.preventDefault();

        this.setState({ redirectBack: true });

      }

      return;

    }



    if (focusedSection === SECTION.BACK_BUTTON) {

      if (keyCode === KEY_LEFT) {

        this.focusSection(SECTION.RIGHT_COLUMN);

      } else if (keyCode === tvKeyControls.KEY_ENTER || keyCode === tvKeyControls.KEY_BACK) {

        event.preventDefault();

        this.setState({ redirectBack: true });

      }

    }

  }



  render() {

    if (this.state.redirectBack) {

      return <Navigate to={Route.route.LANDING} />;

    }



    if (this.state.sourceRedirect != null) {

      var redirect = this.state.sourceRedirect;

      return (
        <Navigate
          to={buildSourceRoutePath(redirect.type, redirect.number)}
          state={{ returnTo: Route.route.SETTINGS }}
        />
      );

    }



    const {

      focusedSection,

      leftFocusIndex,

      rightFocusIndex,

      selectedLanguageId,

      categories,

    } = this.state;



    const rightItems = this.getRightItems();

    const activeCategory = categories[leftFocusIndex];

    const selectedRightItemId =

      activeCategory && activeCategory.id === CATEGORY_LANGUAGE ? selectedLanguageId : null;



    return (

      <Container>

        <HeaderBarComponent />

        <OuterContentContainer>

          <ContentContainer>

            <PageHeader

              title={t('Settings.settings')}

              ref={this.backButtonRef}

              onBack={() => this.setState({ redirectBack: true })}

              backFocused={focusedSection === SECTION.BACK_BUTTON}

            />

            <SettingsPanel

              categories={categories}

              leftFocusIndex={leftFocusIndex}

              leftSectionFocused={focusedSection === SECTION.LEFT_COLUMN}

              rightItems={rightItems}

              rightFocusIndex={rightFocusIndex}

              rightSectionFocused={focusedSection === SECTION.RIGHT_COLUMN}

              selectedRightItemId={selectedRightItemId}

              onCategoryClick={(index) => {
                this.setState({ leftFocusIndex: index, rightFocusIndex: 0 }, () => {
                  this.focusSection(SECTION.RIGHT_COLUMN);
                });
              }}
              onRightItemClick={(index) => {
                const category = categories[leftFocusIndex];
                this.setState({ rightFocusIndex: index });
                const item = this.getRightItems()[index];
                if (!item) {
                  return;
                }
                if (category && category.id === CATEGORY_SOURCE) {
                  this.openSource(item);
                } else {
                  this.setLocale(item.id);
                }
              }}

            />

          </ContentContainer>

        </OuterContentContainer>

      </Container>

    );

  }

}



export default WarwickSettings;
